<template>
    <Menu as="div" class="inline-block text-left">
        <div class="flex items-center justify-center">
            <MenuButton
                class="inline-flex justify-center w-full bg-white focus:outline-none h-4 items-center">
                <img src="../../../assets/icons/dots-gray.svg" class="mt-1" alt="options"/>
            </MenuButton>
        </div>
        <transition enter-active-class="transition ease-out duration-100" enter-from-class="transform opacity-0 scale-95"
                    enter-to-class="transform opacity-100 scale-100" leave-active-class="transition ease-in duration-75"
                    leave-from-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">
            <MenuItems
                class="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-100 focus:outline-none z-[100]">
                <div class="py-1">
                    <MenuItem
                        v-if="!isInArticle"
                        as="div"
                        @click="emit('view')"
                        class="group flex items-center py-2 pr-5 pl-4 text-body-6 text-default-1 hover:bg-background-3 cursor-pointer"
                    >
                        <img src="../../../assets/icons/eye-dark.svg" class="h-5 w-5 mr-2.5" alt="view"/>
                        View
                    </MenuItem>
                    <MenuItem
                        v-if="isOnCurrentOrganization"
                        as="div"
                        @click="emit('edit')"
                        class="group flex items-center py-2 pr-5 pl-4 text-body-6 text-default-1 hover:bg-background-3 cursor-pointer"

                    >
                        <img src="../../../assets/icons/edit.svg" class="h-5 w-5 mr-2.5" alt="edit"/>
                        Edit
                    </MenuItem>
                    <MenuItem
                        v-if="isScheduled && isOnCurrentOrganization"
                        as="div"
                        @click="emit('reschedule')"
                        class="group flex items-center py-2 pr-5 pl-4 text-body-6 text-default-1 hover:bg-background-3 cursor-pointer"
                    >
                        <img src="../../../assets/icons/schedule-dark.svg" class="h-5 w-5 mr-2.5" alt="schedule"/>
                        Reschedule
                    </MenuItem>
                    <MenuItem
                        as="div"
                        v-if="!isTrashed && isOnCurrentOrganization"
                        @click="emit('share')"
                        class="group flex items-center py-2 pr-5 pl-4 text-body-6 text-default-1 hover:bg-background-3 cursor-pointer">
                        <img src="../../../assets/icons/share-black.svg" class="h-5 w-5 mr-2.5" alt="share"/>
                        Share
                    </MenuItem>
                    <MenuItem
                            as="div"
                            v-if="!isTrashed && isOnCurrentOrganization"
                            @click="emit('delete')"
                            class="group flex items-center py-2 pr-5 pl-4 text-body-6 text-default-1 hover:bg-background-3 cursor-pointer">
                        <Bin color="#343A40" class="h-5 w-5 mr-2.5" />
                        Delete
                    </MenuItem>
                </div>
            </MenuItems>
        </transition>
    </Menu>
</template>
<script setup>
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'
import Bin from "@/components/icons/small/Bin.vue";

const emit = defineEmits(['view','share','edit','reschedule', 'delete']);

const props = defineProps({
    isScheduled: {
        type: Boolean,
        required: false,
        default: false,
    },
    isInArticle: {
        type: Boolean,
        required: false,
        default: false,
    },
    isTrashed: {
        type: Boolean,
        required: false,
        default: false,
    },
    isOnCurrentOrganization: {
        type: Boolean,
        required: false,
        default: false,
    },
    hasShare: {
        type: Boolean,
        required: false,
        default: true,
    }
});

</script>
